export default "__VITE_ASSET__CRR_8nut__"